export default __webpack_public_path__ + "static/media/dexscreener.a6ff20dd.svg";